var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemaleClipped(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2097_10130",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 79,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5838 77.5711C61.0864 77.5711 78.5177 60.2863 78.5177 38.9644C78.5177 17.6425 61.0864 0.357666 39.5838 0.357666C18.0812 0.357666 0.649902 17.6425 0.649902 38.9644C0.649902 60.2863 18.0812 77.5711 39.5838 77.5711Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2097_10130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.621 27.3628C19.621 27.3628 18.96 40.2754 20.6787 46.3056C22.5956 52.9258 22.199 59.2182 20.1499 61.5779C18.1007 63.9376 39.5838 64.3964 39.5838 64.3964V16.9409C39.5838 16.8754 23.0583 17.072 19.621 27.3628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2821 29.0013C59.2821 29.0013 60.0753 40.0131 57.0347 48.6652C54.0601 57.3173 57.4313 65.445 57.4313 65.445L33.5024 62.561L37.0719 14.2534L59.2821 29.0013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6634 58.7595C43.4838 58.1696 44.0787 49.8452 44.0787 49.8452H39.5838H35.0889C35.0889 49.8452 35.6838 58.104 25.5041 58.7595C15.3245 59.3494 8.58208 64.0032 8.78038 77.5713H39.5838H70.3872C70.5855 64.0032 63.8431 59.3494 53.6634 58.7595Z",
    fill: "#EABF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5751 55.8755C46.4582 55.941 49.6311 63.6755 49.6311 63.6755L55.3819 58.8906C54.8531 58.825 54.2582 58.7595 53.6633 58.7595C43.4836 58.1696 44.0785 49.8452 44.0785 49.8452H39.5836H35.0887C35.0887 49.8452 35.2209 52.0082 34.0972 54.1713C34.8243 54.8267 36.6751 55.8099 40.5751 55.8755Z",
    fill: "#E1AC85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4312 29.7224C57.4312 41.6518 47.7804 54.1711 39.5838 54.1711C31.3872 54.1711 21.7363 41.7174 21.7363 29.7224C21.7363 17.793 29.7346 10.9106 39.5838 10.9106C49.4329 10.9106 57.4312 17.793 57.4312 29.7224Z",
    fill: "#EABF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6634 58.7594C52.5396 58.6938 51.5481 58.5627 50.6888 58.3005C43.2854 62.8888 35.882 62.8888 28.4125 58.3005C27.5532 58.4972 26.5617 58.6938 25.438 58.7594C15.2583 59.3493 8.51592 64.0031 8.71422 77.5711H39.5176H70.321C70.5854 64.0031 63.843 59.3493 53.6634 58.7594Z",
    fill: "#143A72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8753 19.956C28.8753 19.956 40.5753 29.919 57.4313 28.9359H59.2821C59.2821 28.9359 58.6211 14.9745 49.2347 9.59972C39.9143 4.22493 27.6855 8.81317 26.8262 13.3359C26.8262 13.3359 20.1499 15.5644 19.6211 28.6081L21.7363 28.5426C21.7363 28.5426 27.2889 26.0518 28.8753 19.956Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleClipped);
export default __webpack_public_path__ + "static/media/femaleClipped.ed6079676a2e20c209be346c1446db70.svg";
export { ForwardRef as ReactComponent };